import { NavHistoryConfigProvider } from '@portals/shared-frontend/hooks';
import { type ReactNode, useMemo } from 'react';

import { buildUserNavHistoryStorageKey, DEFAULT_NAV_HISTORY_STORAGE_KEY } from '@/constants/navHistory';
import { NAV_HISTORY_MAX_ENTRIES, NAV_HISTORY_MAX_PINNED } from '@/constants/navHistory';
import { useUser } from '@/hooks/useUser';

export function UserNavHistoryConfigProvider({ children }: { children: ReactNode }) {
  const { user } = useUser();

  const storageKey = useMemo(
    () => (user?.id ? buildUserNavHistoryStorageKey(user.id) : DEFAULT_NAV_HISTORY_STORAGE_KEY),
    [user?.id],
  );

  return (
    <NavHistoryConfigProvider
      maxEntries={NAV_HISTORY_MAX_ENTRIES}
      maxPinned={NAV_HISTORY_MAX_PINNED}
      storageKey={storageKey}
    >
      {children}
    </NavHistoryConfigProvider>
  );
}
